import { Box, Card, CardContent, Stack, Typography, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import { observer } from 'mobx-react-lite';

type PaymentCardProps = {
    payment: {
        id: string | number;
        formId?: string;
        amount?: string | number;
        status?: string;
        createdAt?: string;
        invId: string;
        outSum: string;
        isUsed: boolean;
        [key: string]: any;
    };
};

const PaymentCard = observer(({ payment }: PaymentCardProps) => {
    const theme = useTheme();

    const formatDate = (dateString?: string) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return '';
        }
    };

    const formatAmount = (amount?: string | number) => {
        if (!amount) return '';
        const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            minimumFractionDigits: 0
        }).format(numAmount);
    };

    const getStatusText = () => {
        if (payment.isUsed) return 'Использован';
        return 'Оплата принята';
    };

    const title = `Платеж ${payment.invId}`;
    const description = `Дата: ${formatDate(payment.createdAt)}`

    return (
        <Card
            sx={{
                height: '100%',
                transition: 'all 0.2s ease',
                border: `1px solid ${theme.palette.divider}`,
                '&:hover': {
                    borderColor: theme.palette.primary.main,
                    boxShadow: theme.customShadows.z8,
                    transform: 'translateY(-2px)'
                }
            }}
        >
            <CardContent sx={{ p: 3, pb: '14px !important' }}>
                <Stack direction="row" alignItems="center" spacing={4}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: 2,
                            backgroundColor: theme.palette.primary.lighter,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            color: theme.palette.primary.main
                        }}
                    >
                        <Icon icon="mdi:credit-card" width={28} height={28} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
                            {title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                           {description}
                        </Typography>
                        {payment.outSum &&(
                            <Typography variant="body2" color="text.secondary">
                                Сумма: {formatAmount(payment.outSum)}
                            </Typography>
                        )}
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                            Статус: {getStatusText()}
                        </Typography>
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
});

export default PaymentCard;

